module.exports = __webpack_public_path__ + "img/ec-logo-white-mobile.f4115bb2.svg";